<template>
  <div class="page-404 d-flex">
    <div class="d-flex flex-column column align-items-center justify-content-center">
      <b-row class="w-100">
        <b-col class="d-flex align-items-center justify-content-center">
          <div>
            <h1>{{ $t('component.page404.sorry') }}</h1>
            <h3>{{ $t('component.page404.text') }}</h3>
          </div>
        </b-col>
      </b-row>
      <div>
        <b-row
          class="mt-5"
          style="width:100%"
        >
          <b-col>
            <b-button
              block
              class="btn__outline btn__outline--light"
              size="lg"
              data-dismiss="modal"
              @click="goBack"
            >
              <i
                class="fal fa-arrow-left mr-2"
                aria-hidden="true"
              />{{ $t('component.page404.back') }}
            </b-button>
          </b-col>
          <b-col>
            <b-button
              :to="{ name: 'home' }"
              block
              class="btn__outline btn__outline--light ml-2"
              size="lg"
              data-dismiss="modal"
            >
              <i
                class="fal fa-home-lg mr-2"
                aria-hidden="true"
              />{{ $t('global.home') }}
            </b-button>
          </b-col>
        </b-row>
        <b-row
          class="mt-5"
          style="width:100%;"
        >
          <b-col>
            <span>{{ $t('component.page404.help') }}</span><br>
            <span>{{ $t('component.page404.contact') }} <a
              class="link"
              href="#"
            >{{ $t('component.page404.mail') }}</a></span>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'Page404',
    methods: {
        goBack() {
            this.$router.go(-1)
        }
    }
}
</script>

<style lang="scss" scoped>

.page-404 {
    background: url('../../img/page-no-found.jpg');
    height: 100vh;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    }

.page-404 .column{
    height: 100%;
    width: 50%;
}

.page-404 .column div{
    width: 50%;
}

.page-404 .column div h1{
    color: #FFF;
    font-size: 3.5rem;
}

.page-404 .column div h3{
    color: #FFF;
    margin-top: 30px;
}

.no-found-btn{
    color: #FFF;
    border-color: #FFF;
    font-size: 1.3rem;
    padding: 5px 20px;
}

.no-found-btn:hover{
    background: #FFF;
    color: vt-color(primary);
}

.page-404 span{
    color: #FFF;
}

.page-404 .link{
    color: #FFF;
    text-decoration: underline;
}

.page-404 .link:hover{
    color: vt-color(light-primary);
}

</style>
